import Icon from '@rio-cloud/rio-uikit/components/icon/Icon';
import OverlayTrigger from '@rio-cloud/rio-uikit/components/overlay/OverlayTrigger';
import Popover from '@rio-cloud/rio-uikit/components/popover/Popover';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { CustomIcon, ListGroupItem, MessageActionWrapper } from '@/components/molecule/ChatActions/ChatActions.styles';
import { getDisplayMessages } from '@/configuration/lang/langSlice';
import { useAppSelector } from '@/configuration/setup/hooks';
import { exportResponseToPDF } from '@/utils/export/exportResponseToPDF/exportResponseToPDF';

type ChatActionsProps = {
  question: string;
  message: string;
  handleSend: (content: string, isOnboarding: boolean, shouldClosePopOver: boolean) => void;
};

export const ChatActions = ({ question, message, handleSend }: ChatActionsProps) => {
  const handleRegenerate = () => handleSend(question, false, true);

  const displayMessages = useAppSelector(getDisplayMessages) ?? {};
  const handleExportToPDF = () => {
    return exportResponseToPDF(question, message, displayMessages);
  };

  const actionProps = [
    {
      icon: 'icon-pdf-file',
      text: 'chatPage.chatActions.tooltip.exportToPDF.label',
      onClick: handleExportToPDF,
      dataTestId: 'export-chat-pdf-button',
    },
    {
      icon: 'icon-repeat',
      text: 'chatPage.chatActions.tooltip.regenerate.label',
      onClick: handleRegenerate,
      dataTestId: 'regenerate-answer-button',
    },
  ];

  const [showPopover, setShowPopover] = useState(false);

  return (
    <MessageActionWrapper className="btn-toolbar">
      <OverlayTrigger
        show={showPopover}
        onToggle={setShowPopover}
        trigger="click"
        placement="right"
        overlay={
          <Popover
            id="popover-extended-sample"
            titleClassName="bg-lightest rounded-top"
            contentClassName="padding-0"
            data-testid="chat-options-tooltip"
          >
            <div className="margin-8">
              <div className="list-group rounded">
                {actionProps.map((action) => (
                  <ListGroupItem
                    data-testid={action.dataTestId}
                    onClick={action.onClick}
                    key={action.icon}
                    className="text-size-12"
                  >
                    <Icon iconName={action.icon} />
                    <FormattedMessage id={action.text} />
                  </ListGroupItem>
                ))}
              </div>
            </div>
          </Popover>
        }
      >
        <div>
          <CustomIcon className={showPopover ? 'active' : ''}>
            <Icon iconName="icon-keyboard" />
          </CustomIcon>
        </div>
      </OverlayTrigger>
    </MessageActionWrapper>
  );
};
